import { render, staticRenderFns } from "./officeSuppliesCollectionList.vue?vue&type=template&id=4b640089&scoped=true"
import script from "./officeSuppliesCollectionList.vue?vue&type=script&lang=js"
export * from "./officeSuppliesCollectionList.vue?vue&type=script&lang=js"
import style0 from "./officeSuppliesCollectionList.vue?vue&type=style&index=0&id=4b640089&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b640089",
  null
  
)

export default component.exports